const SITE_KEY = process.env.REACT_APP_RECAPTCHA_SITE_KEY;

export async function executeRecaptcha(action = 'submit') {
  if (!SITE_KEY) {
    console.warn('reCAPTCHA site key not configured; skipping verification in development.');
    return 'dev-bypass-token';
  }

  return new Promise((resolve, reject) => {
    const run = () => {
      if (!window.grecaptcha?.execute) {
        reject(new Error('reCAPTCHA not loaded'));
        return;
      }
      window.grecaptcha
        .execute(SITE_KEY, { action })
        .then(resolve)
        .catch(reject);
    };

    if (window.grecaptcha?.execute) {
      run();
    } else {
      const interval = setInterval(() => {
        if (window.grecaptcha?.execute) {
          clearInterval(interval);
          run();
        }
      }, 100);
      setTimeout(() => {
        clearInterval(interval);
        reject(new Error('reCAPTCHA load timeout'));
      }, 8000);
    }
  });
}

export function loadRecaptchaScript() {
  if (!SITE_KEY || document.getElementById('recaptcha-v3')) return;
  const script = document.createElement('script');
  script.id = 'recaptcha-v3';
  script.src = `https://www.google.com/recaptcha/api.js?render=${SITE_KEY}`;
  script.async = true;
  document.head.appendChild(script);
}
